import React from 'react';
import { Button } from 'reactstrap';
import './book-event-form-actions.scss';
import { useTranslation } from 'react-i18next';
import {
  useCloseOldModal,
  useSetUnmountModalCallback,
} from '../../../../../store/modal/modalHooks';
import { useQuery } from '../../../../../utility/hooks/useQuery';

type Props = {
  waitingListMode: boolean;
  onJoinWaitingList: () => void;
  onBookEvent: () => Promise<void>;
};

const BookEventFormActions = ({
  waitingListMode,
  onBookEvent,
  onJoinWaitingList,
}: Props) => {
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();
  const setUnmountModalCallback = useSetUnmountModalCallback();
  const { query, setQuery, clearQuery, isQueryInit, isQueryEmpty } = useQuery();

  const onCloseModal = () => {
    setUnmountModalCallback(undefined);
    closeModal();
    clearQuery('eventId');
  };

  return (
    <div className="book-event-form-actions">
      {waitingListMode ? (
        <Button
          className="confirm-booking-event-button"
          type="button"
          onClick={onJoinWaitingList}
          color="transparent"
          style={{ backgroundColor: '#ea5455', color: 'white' }}
        >
          {t('JOIN_WAITING_LIST')}
        </Button>
      ) : (
        <Button
          className="confirm-booking-event-button"
          type="button"
          onClick={onBookEvent}
          color="primary"
        >
          {t('BOOK_EVENT')}
        </Button>
      )}
      <Button
        className="cancel-booking-event-button"
        type="button"
        color="transparent"
        onClick={onCloseModal}
      >
        {t('CLOSE_BUTTON')}
      </Button>
    </div>
  );
};

export default BookEventFormActions;
